import clsx from 'clsx';
import type { RefObject, MouseEvent } from 'react';
import { Icon } from '../icon/icon.component';
import { style } from './option-icon.module.css';

interface Props {
  icon: string;
  iconRef?: RefObject<HTMLDivElement | null>;
  className?: string;
  variant?: 'outlined' | 'round';
  disabled?: boolean;
  onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
}

export function OptionIcon(props: Props) {

  const {
    icon,
    iconRef,
    className,
    variant,
    disabled,
    onClick,
  } = props;

  return (
    <Icon
      className={clsx(style.icon, disabled && style.disabled, className)}
      icon={icon}
      iconRef={iconRef}
      variant={variant}
      onClick={onClick}/>
  );
}
